module.exports = __webpack_public_path__ + "static/media/travel.d3d1a195.svg";